import * as React from 'react';
import IconButton from '../../../components/button/IconButton';
import ConfirmButton from '../../../components/button/ConfirmButton';
import { Actions } from '../../../../client/Actions';
import ConfirmIconButton from '../../../components/button/ConfirmIconButton';
import { useTranslation } from 'react-i18next';
import { hasAdmin } from '../../../helpers/jwt';

const columns = (t) => {
  return [
    {
      label: 'tableTemplate.idTemplate',
      field: 'id',
      sort: 'desc',
      width: 53,
    },
    {
      label: 'tableTemplate.templateName',
      field: 'templateName',
      sort: 'desc',
      width: 53,
    },
    {
      label: 'tableTemplate.internalNumber',
      field: 'internalNumber',
      sort: 'desc',
      width: 53,
    },
    {
      field: 'toolLabelling',
      label: 'tableTemplate.toolLabelling',
      sort: 'desc',
      width: 53,
    },
    {
      field: 'productName',
      label: 'tableTemplate.productName',
      sort: 'desc',
      width: 53,
      type: 'dictionary',
    },
    {
      field: 'multipleTool',
      label: 'tableTemplate.multipleTool',
      sort: 'desc',
      width: 53,
      type: 'boolean',
    },
    {
      field: 'actions',
      label: 'tableTemplate.actions',
      sort: 'desc',
      width: 53,
      type: 'custom',
      custom: function (column, row, history, reload, setReload, setLoader) {
        return (
          <>
            {' '}
            {!hasAdmin() && (
              <ConfirmIconButton
                className={'btn-circle'}
                variant="outline-danger"
                icon="fa-trash"
                size={'sm'}
                tooltip={t('tableTemplate.tooltipDelete')}
                confirmTitle={t('tableTemplate.deleteTemplateTitle')}
                confirmDescription={t(
                  'tableTemplate.deleteTemplateDescription'
                )}
                onConfirm={() => {
                  setLoader(true);
                  Actions.delete('toolSetTemplate/' + row.id, {}, () => {
                    setReload(!reload);
                  });
                }}
                modalSize={'md'}
              />
            )}
          </>
        );
        // <IconButton
        //     size={"sm"}
        //     onClick={() => {
        //         Actions.
        //         history.push("/verification/" + row.id);
        //     }}
        //     variant="outline-danger"
        //     icon="fa-arrow-right"
        //     tooltip={"Usuń"}
        // />
        // <Button as="a" size={"sm"} variant="outline-danger" className="btn-circle ml-1 tableInfoBtn"
        //                role="button"
        //                onClick={() => {
        //                    history.push("/verification/" + row.id);
        //                }}>
        // </Button>;
      },
    },
  ];
};

export default columns;
